/** AttributeSection
 * Author: Robert Rolland (robert.rolland@nuvoola.com)
 * Date: Wednesday, July 20, 2022
 * 
 * This control is a mariage between the view control (InfoSection) and the
 * edit control (FormSection).  It is intended for a more scalable control
 * that contains both functionalities since they usually need to be dropped
 * in the same location structurally in a view/edit page.
 */

import React from "react";
import InfoSection from "./InfoSection";
import FormSection from "./FormSection";

const AttributeSection = props => {
    const {
        classes, 
        language,
        attribute,
        title,
        title2,
        values,
        link,
        setFormValue,
        id,
        type = "input",
        options = {},
        permission=false,
        isEditMode
    } = props;

    return (
        <>
        { isEditMode ?
            <div style={{padding: "0 8px"}}>
                <FormSection
                    classes={classes}
                    formValue={values}
                    setFormValue={setFormValue}
                    title={title}
                    title2={title2}
                    id={id}
                    type={type}
                    options={options}
                    attribute={attribute}
                    permission={permission}
                />
            </div>
        :
            <InfoSection 
                classes={classes}
                language={language}
                attribute={attribute}
                title={title}
                title2={title2}
                values={values}
                link={link}
            />
        }
        </>
    );
};

export default AttributeSection;